import React from 'react'
import { Switch, Route } from 'react-router-dom'

import LoginView, { ProtectedRoute } from './LogIn'
import MainView from './containers/MainView'

class App extends React.Component {
  state = {
    error: false
  }
  componentDidCatch() {
    this.setState({
      error: true
    })
  }

  render = () => (
    <Switch>
      <Route path="/login" component={LoginView} />
      <ProtectedRoute path="/" component={MainView} />
    </Switch>
  )
}

export default App



// WEBPACK FOOTER //
// ./src/App.js